import { t } from "@travily/i18n";
import { ToggleChip, ToggleChipGroup } from "@ui/components/ToggleChip";
import { keysToArray } from "@ui/lib/selection";
import type { Selection } from "@ui/primitives/shared";
import { UTC_OFFSETS, type UtcOffset } from "../../../filter-values";

export type { UtcOffset };

function offsetLabel(offset: UtcOffset): string {
  if (offset === 0) return "UTC";
  return offset > 0 ? `+${offset}` : String(offset);
}

export interface TimezoneFilterProps {
  onChange: (offsets: UtcOffset[]) => void;
  value: UtcOffset[];
}

export function TimezoneFilter({ onChange, value }: TimezoneFilterProps) {
  const handleSelectionChange = (keys: Selection) => {
    onChange(keysToArray(keys, () => [...UTC_OFFSETS]).map((key) => Number(key) as UtcOffset));
  };

  return (
    <ToggleChipGroup
      aria-label={t("components.views.destinations.search.timezone_label")}
      className="grid-cols-4"
      onSelectionChange={handleSelectionChange}
      selectedKeys={new Set(value.map(String))}
      selectionMode="multiple"
    >
      {UTC_OFFSETS.map((offset) => (
        <ToggleChip className="text-sm" id={String(offset)} key={offset}>
          {offsetLabel(offset)}
        </ToggleChip>
      ))}
    </ToggleChipGroup>
  );
}
